import { useEffect, useState } from "react";
import { API } from "../../ApiServices/apis";
import api from "../../composables/app";
import { getAllCharacters } from "../../ApiServices/Characters";
import characterStore from "../../store/CharactersStore";

const useCharacterDetails = () => {
    const [loading, setLoading] = useState(true);
    const [setCharacters] = characterStore((state) => [state.setCharacters]);
    const getallcharacters = async () => {
        setLoading(true);
        try {
            const response = await getAllCharacters()
            const data = response?.data?.data?.characters || [];
            setCharacters(data);
        } catch (error) {
            console.error("Error fetching character data:", error);
        } finally {
            setLoading(false);
        }
    };

    const deleteCharacter = async (kidId) => {
        try {
            const url = `${API.story.getChildDetails}/${kidId}`;

            await api.delete(url);
            setCharacters(characterData.filter((kid) => kid.id !== kidId));
        } catch (error) {
            console.error("Error deleting kid:", error);
        }
    };

    useEffect(() => {
        getallcharacters();
    }, []);

    return { loading, deleteCharacter };
};
export default useCharacterDetails;
